<template>
  <v-dialog v-model="dialog" max-width="700" @click:outside="cancel">
    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" sm="6">
              <v-card-title class="pa-0">Start Date</v-card-title>
              <v-date-picker
                v-model="start"
                :max="maxStart"
                outlined
                elevation="2"
                :rules="[$rules.required]"
              ></v-date-picker>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card-title class="pa-0">End Date</v-card-title>
              <v-date-picker
                v-model="end"
                :min="minEnd"
                outlined
                elevation="2"
                :rules="[$rules.required]"
              ></v-date-picker>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="apply">
          Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment-timezone";
export default {
  name: "TimeframeSelectDialog",
  props: {},
  data: () => ({
    dialog: false,
    start: moment()
      .subtract(3, "M")
      .format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
    valid: false
  }),
  computed: {
    maxStart() {
      return moment(this.end)
        .subtract(1, "d")
        .format("YYYY-MM-DD");
    },
    minEnd() {
      return moment(this.start)
        .add(1, "d")
        .format("YYYY-MM-DD");
    }
  },
  methods: {
    showDialog(filter) {
      this.dialog = true;
      this.start = (filter.customStartDate
        ? moment(filter.customStartDate)
        : moment().subtract(3, "M")
      ).format("YYYY-MM-DD");
      this.end = (filter.customEndDate
        ? moment(filter.customEndDate)
        : moment()
      ).format("YYYY-MM-DD");
    },
    apply() {
      if (this.$refs.form.validate()) {
        this.$emit("apply", {
          customTimezone: moment.tz.guess(true),
          customStartDate: this.start,
          customEndDate: this.end
        });
        this.dialog = false;
      }
    },
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    }
  }
};
</script>
